module.exports = __webpack_public_path__ + "img/fb-grey.887ab233.svg";